import type { WebElement } from '../types'
import { TrackingEvent, ElementType, type CustomDimensions } from '../types'

export interface ElementViewedArgs {
  webElement: WebElement
  customDimensions?: CustomDimensions[]
}

export interface ElementViewedProperties {
  webElement: WebElement
  customDimensions?: CustomDimensions[]
}

export class ElementViewed extends TrackingEvent {
  properties: ElementViewedProperties

  constructor(args: ElementViewedArgs) {
    super('ElementViewed', 'redventures.usertracking.v3.ElementViewed')
    const {
      webElement = {
        elementType: ElementType.None,
        location: '',
        name: '',
        position: '0',
        text: '',
      },
      customDimensions = [],
    } = args ?? {}

    this.properties = {
      webElement: {
        elementType: webElement.elementType,
        location: webElement.location,
        name: webElement.name,
        position: webElement.position,
        text: webElement.text,
      },
      customDimensions,
    }
  }
}
